<!--
 * @Descripttion:
 * @Author: liang
 * @Date: 2021-04-20 11:15:47
 * @LastEditors: liang
 * @LastEditTime: 2021-09-13 16:05:34
-->
<template>
  <div>
    <el-dialog
      title="注册"
      :visible.sync="regShow"
      width="60%"
      :append-to-body="true"
      @before-close="closeDialog"
      :close-on-click-modal="false"
    >
      <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="120px">
      <div style="color:#F56C6C;margin-left:40px;margin-bottom:20px;"><i class="el-icon-warning"></i> 手机号为登录账号；只支持个人用户注册，单位从业人员请联系自己公司进行注册。</div>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item prop="realName" label="真实姓名">
              <el-input v-model="dataForm.realName" placeholder="真实姓名"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="mobile" label="手机号">
              <el-input v-model="dataForm.mobile" placeholder="手机号"></el-input>
            </el-form-item>
          </el-col>
          <div style="color:#F56C6C;margin-left:80px;margin-bottom:20px;"><i class="el-icon-warning"></i> 密码长度应该在4-16个字符。</div>
          <el-col :span="12">
            <el-form-item prop="password" label="密码">
              <el-input v-model="dataForm.password" type="password" placeholder="密码"></el-input>
              <!-- <div style="color:#F56C6C;margin-bottom:20px;"><i class="el-icon-warning"></i> 密码长度应该在4-16个字符。</div> -->
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="confirmPassword" label="确认密码">
              <el-input v-model="dataForm.confirmPassword" type="password" placeholder="确认密码"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="gender" label="性别">
              <el-radio-group v-model="dataForm.gender">
                <el-radio :label="0">男</el-radio>
                <el-radio :label="1">女</el-radio>
                <el-radio :label="2">保密</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="email" label="邮箱">
              <el-input v-model="dataForm.email" placeholder="邮箱"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="idCard" label="身份证号">
              <el-input v-model="dataForm.idCard" placeholder="身份证号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template slot="footer">
        <el-button @click="regShow = false">取消</el-button>
        <el-button type="primary" @click="submitForm('dataForm')" :loading='btnload'>确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'userregister',
  data () {
    return {
      regShow: false,
      btnload: false,
      dataForm: {
        password: '',
        confirmPassword: '',
        realName: '',
        gender: 0,
        email: '',
        mobile: '',
        idCard: ''
      }
    }
  },
  computed: {
    dataRule () {
      var validatePassword = (rule, value, callback) => {
        if (!/\S/.test(value)) {
          return callback(new Error('请输入密码'))
        }
        callback()
      }
      var validateComfirmPassword = (rule, value, callback) => {
        if (!/\S/.test(value)) {
          return callback(new Error('请确认密码'))
        }
        if (this.dataForm.password !== value) {
          return callback(new Error('确认密码与密码输入不一致'))
        }
        callback()
      }
      var validateEmail = (rule, value, callback) => {
        if (!/^([a-zA-Z0-9._-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(value)) {
          return callback(new Error('邮箱格式不正确'))
        }
        callback()
      }
      var validateMobile = (rule, value, callback) => {
        if (!/^1[0-9]{10}$/.test(value)) {
          return callback(new Error('手机号格式不正确'))
        }
        callback()
      }
      var validateCardNo = (rule, value, callback) => {
        if (!/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(value)) {
          return callback(new Error('身份证号格式不正确'))
        }
        callback()
      }
      return {
        password: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur'
          },
          { min: 4, max: 16, message: '密码长度在 4 到 16 个字符', trigger: 'blur' },
          { validator: validatePassword, trigger: 'blur' }
        ],
        confirmPassword: [
          {
            required: true,
            message: '请确认密码',
            trigger: 'blur'
          },
          { min: 4, max: 16, message: '密码长度在 4 到 16 个字符', trigger: 'blur' },
          { required: true, validator: validateComfirmPassword, trigger: 'blur' }
        ],
        gender: [
          {
            required: true,
            message: '请选择性别',
            trigger: ['change', 'blur']
          }
        ],
        realName: [
          {
            required: true,
            message: '请输入真实姓名',
            trigger: 'blur'
          }
        ],
        email: [
          {
            required: true,
            message: '请输入邮箱',
            trigger: 'blur'
          },
          { validator: validateEmail, trigger: 'blur' }
        ],
        mobile: [
          {
            required: true,
            message: '请输入手机号',
            trigger: 'blur'
          },
          { validator: validateMobile, trigger: 'blur' }
        ],
        idCard: [
          {
            required: true,
            message: '请输入身份证号',
            trigger: 'blur'
          },
          { validator: validateCardNo, trigger: 'blur' }
        ]
      }
    }
  },
  created () {
  },
  methods: {
    init () {
      this.regShow = true
    },
    closeDialog () {
      this.regShow = false
    },
    submitForm (formName) {
      console.log(this.$refs[formName])
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return false
        }
        this.btnload = true
        this.$post('/sys/user/userRegister', this.dataForm).then((res) => {
          this.btnload = false
          if (res.code === 0) {
            console.log(res)
            this.$message.success('操作成功')
            this.regShow = false
            this.$refs[formName].resetFields()
          }
        }).catch(() => {})
      })
    }
  }
}
</script>

<style scoped>
</style>
